import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@strava/ui/Button';
import Switch from '@strava/ui/Switch';
import SvgActionsVisibleDisabledNormalMedium from '@strava/icons/ActionsVisibleDisabledNormalMedium';
import SvgActivityDistanceNormalMedium from '@strava/icons/ActivityDistanceNormalMedium';
import SvgActionsGlobalNormalMedium from '@strava/icons/ActionsGlobalNormalMedium';

import I18n from 'utils/I18n';
import createNetworkingClient from 'utils/networking-client';
import styles from './styles.scss';

function MapVisibilityControls({
  numPrivateLocations,
  defaultStreamPrivacy,
  defaultActivityMapVisibility,
  paths
}) {
  const i18nPrefix = 'strava.settings.privacy.map_visibility.';
  const [mapsHidden, setMapsHidden] = useState(
    defaultActivityMapVisibility !== 'everyone'
  );

  const handleSwitchUpdate = () => {
    const newMapVisibility = mapsHidden ? 'everyone' : 'only_me';
    createNetworkingClient()
      .put(paths.athleteSettings, {
        settings: { default_activity_map_visibility: newMapVisibility }
      })
      .then(() => {
        setMapsHidden(newMapVisibility !== 'everyone');
      });
  };

  return (
    <div>
      <h3 className={styles.header}>{I18n.t(`${i18nPrefix}header`)}</h3>
      <a
        href="https://support.strava.com/hc/en-us/articles/115000173384"
        className={styles.learnMore}
      >
        {I18n.t(`${i18nPrefix}learn_more`)}
      </a>
      <div className={styles.hideAddress}>
        <SvgActivityDistanceNormalMedium />
        <div>
          <div>{I18n.t_html(`${i18nPrefix}hide_address_html`)}</div>
          <div>
            {I18n.t_html(`${i18nPrefix}address_hidden_html`, {
              count: numPrivateLocations,
              url: paths.hideAddress
            })}
          </div>
        </div>
        <Button
          type="button"
          className={styles.addEditButton}
          onClick={() => {
            window.location.href = paths.hideAddress;
          }}
        >
          {I18n.t(
            numPrivateLocations ? `${i18nPrefix}edit` : `${i18nPrefix}add`
          )}
        </Button>
      </div>
      <div className={styles.hideAnywhere}>
        <SvgActionsGlobalNormalMedium />
        <div>{I18n.t_html(`${i18nPrefix}hide_anywhere_html`)}</div>
        <Button
          type="button"
          className={styles.addEditButton}
          onClick={() => {
            window.location.href = paths.hideAnywhere;
          }}
        >
          {I18n.t(
            defaultStreamPrivacy === 'disabled'
              ? `${i18nPrefix}add`
              : `${i18nPrefix}edit`
          )}
        </Button>
      </div>
      <div className={styles.hideAll}>
        <SvgActionsVisibleDisabledNormalMedium />
        <div>
          <div className={styles.hideAllLabel}>
            {I18n.t_html(`${i18nPrefix}hide_all`)}
          </div>
          <div className={styles.hideAllDetail}>
            {I18n.t_html(`${i18nPrefix}hide_all_detail_html`)}
          </div>
        </div>
        <Switch
          name="default-activity-map-visibility"
          className={styles.switch}
          checked={mapsHidden}
          onClick={handleSwitchUpdate}
        />
      </div>
    </div>
  );
}

MapVisibilityControls.propTypes = {
  numPrivateLocations: PropTypes.number.isRequired,
  defaultStreamPrivacy: PropTypes.string.isRequired,
  defaultActivityMapVisibility: PropTypes.string.isRequired,
  paths: PropTypes.shape({
    hideAddress: PropTypes.string,
    hideAnywhere: PropTypes.string,
    athleteSettings: PropTypes.string
  }).isRequired
};

export default MapVisibilityControls;
